<!-- 问题筛选弹框 -->
<template lang="pug">
div
  van-popup(v-model="popupShow" position="right")
    .screenArea
      .title 筛选
      .content
        van-form(ref="formData" label-width="66px" readonly)
          .label 当前用户
          van-field.checkCell(label="")
            template(#input)
              van-button.checkBtn(v-for="(item,index) in sources" :key="index" :class="screen.currentUserScreenList.includes(item.id)?'checkedBtn':''"
                size="small" @click="checkSource(item)") {{ item.cnName }}
          .label 状态
          van-field.checkCell(label="")
            template(#input)
              van-button.checkBtn(v-for="(item,index) in statusList" :key="index" :class="screen.statusIdList.includes(item.id)?'checkedBtn':''"
                size="small" @click="checkStatus(item)") {{ item.cnName }}
          .label 意见类型
          van-field.checkCell(label="")
            template(#input)
              van-button.checkBtn(v-for="(item,index) in checkTypeList" :key="index" :class="screen.qmTypeIdList.includes(item.id)?'checkedBtn':''"
                size="small" @click="checkQmType(item)") {{ item.cnName }}
          .label 严重等级
          van-field.checkCell(label="")
            template(#input)
              van-button.checkBtn(v-for="(item,index) in severityLevelList" :key="index" :class="screen.problemTypeIdList.includes(item.id)?'checkedBtn':''"
                size="small" @click="checkProblemType(item)") {{ item.cnName }}
          van-field(label="阶段" input-align="right" placeholder="请选择阶段" is-link :value="screen.stageNames" @click="openStage")
          van-field(label="子项" input-align="right" placeholder="请选择子项" is-link :value="screen.stageChildNames" @click="openChild")
          van-field(label="专业" input-align="right" placeholder="请选择专业" is-link :value="screen.specNames" @click="openSpec")
          van-field(label="跨专业" input-align="right" placeholder="请选择跨专业" is-link :value="screen.multiSpecNames" @click="openMultiSpec")
          van-field(label="修改人" input-align="right" placeholder="请选择修改人" is-link :value="screen.modifierNames" @click="openModifier")
          van-field(label="创建人" input-align="right" placeholder="请选择创建人" is-link :value="screen.creatorNames" @click="openCreator")
          van-field(label="来源" input-align="right" placeholder="请选择来源" is-link :value="screen.sourceNames" @click="openSource")
          van-field(label="起始时间" input-align="right" placeholder="请选择起始时间" is-link :value="screen.startCreateTime" @click="startTimeShow=true")
          van-field(label="结束时间" input-align="right" placeholder="请选择结束时间" is-link :value="screen.endCreateTime" @click="endTimeShow=true")
      .buttons
        van-button.button(type="info" round plain @click="reset") 重置
        van-button.button(type="info" round @click="submit") 确定
  //- 阶段弹框
  stageNameSheet(ref="stageNameSheet" multiple @callback="setStage")
  //- 子项弹框
  childNameSheet(ref="childNameSheet" multiple @callback="setChild")
  //- 专业弹框
  specNameSheet(ref="specNameSheet" multiple @callback="setSpec")
  //- 跨专业弹框
  multiSpecSheet(ref="multiSpecSheet" @callback="setMultiSpec")
  //- 修改人弹框
  modifierSheet(ref="modifierSheet" @callback="setModifier")
  //- 创建人弹框
  creatorSheet(ref="creatorSheet" @callback="setCreator")
  //- 来源弹框
  sourceSheet(ref="sourceSheet" multiple @callback="setSource")
  //- 起始时间弹框
  van-calendar(v-model="startTimeShow" ref="startTime" title="起始时间" :min-date="minDate" :show-confirm="false" @confirm="setStartTime")
    template(#footer)
      van-button.timeBtn(round @click="clearStartTime") 清空
  //- 结束时间弹框
  van-calendar(v-model="endTimeShow" ref="endTime" title="结束时间" :min-date="minDate" :show-confirm="false" @confirm="setEndTime")
    template(#footer)
      van-button.timeBtn(round @click="clearEndTime") 清空
</template>
<script>
import { mapState } from "vuex";
import questionService from "@/CommonDP/service/question-service";
import stageNameSheet from "@/CommonDP/pages/appView/issueH5/components/stageNameSheet.vue";
import childNameSheet from "@/CommonDP/pages/appView/issueH5/components/childNameSheet.vue";
import specNameSheet from "@/CommonDP/pages/appView/issueH5/components/specNameSheet.vue";
import multiSpecSheet from "@/CommonDP/pages/appView/issueH5/components/multiSpecSheet.vue";
import modifierSheet from "@/CommonDP/pages/appView/issueH5/components/modifierSheet.vue";
import creatorSheet from "@/CommonDP/pages/appView/issueH5/components/creatorSheet.vue";
import sourceSheet from "@/CommonDP/pages/appView/issueH5/components/sourceSheet.vue";
import moment from "moment";

// 表单
function FormData() {
  return {
    currentUserScreenList: [], // 数据来源
    statusIdList: [], // 状态
    qmTypeIdList: [], // 意见
    problemTypeIdList: [], // 严重
    stageIdList: [], // 阶段
    stageNames: "",
    stageChildIdList: [], // 子项
    stageChildNames: "",
    specIdList: [], // 专业
    specNames: "",
    multiSpecList: [], // 跨专业
    multiSpecNames: "",
    modifierIdList: [], // 修改人
    modifierNames: "",
    createUserIdList: [], // 创建人
    creatorNames: "",
    sourceList: [], // 来源
    sourceNames: "",
    startCreateTime: "",
    endCreateTime: ""
  };
}

export default {
  components: { stageNameSheet, childNameSheet, specNameSheet, multiSpecSheet, modifierSheet, creatorSheet, sourceSheet },
  data() {
    return {
      popupShow: false,
      screen: new FormData(), // 筛选条件
      sources: [
        { id: 1, cnName: "我的创建" },
        { id: 2, cnName: "我的修改" }
      ],
      statusList: [], // 字典项
      checkTypeList: [],
      severityLevelList: [],
      severityLevelList: [],
      startTimeShow: false,
      endTimeShow: false,
      minDate: moment().subtract(3, "M").toDate() // 最小时间
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  mounted() {},
  methods: {
    // 初始化
    init(prjId, fileId) {
      this.getDicList(prjId);
      this.initPopup(prjId, fileId);
    },
    // 初始化弹框
    initPopup(prjId, fileId) {
      this.$refs.stageNameSheet.init(prjId, fileId);
      this.$refs.childNameSheet.init(prjId, fileId);
      this.$refs.specNameSheet.init(prjId, fileId);
      this.$refs.multiSpecSheet.init(prjId, fileId);
      this.$refs.modifierSheet.init(prjId, fileId);
      this.$refs.creatorSheet.init(prjId, "");
      this.$refs.sourceSheet.init(prjId, "");
    },
    // 获得字典项
    async getDicList(prjId) {
      const { data } = await questionService.getH5DrawingQuestionSearchList(prjId);
      let { statusList, checkTypeList, severityLevelList } = data || {};
      this.statusList = statusList || [];
      this.checkTypeList = checkTypeList || [];
      this.severityLevelList = severityLevelList || [];
    },

    // 选择来源（用户）
    checkSource(item) {
      let exist = this.screen.currentUserScreenList.includes(item.id);
      if (exist) this.screen.currentUserScreenList = this.screen.currentUserScreenList.filter((e) => e !== item.id);
      else this.screen.currentUserScreenList.push(item.id);
    },
    // 选择状态
    checkStatus(item) {
      let exist = this.screen.statusIdList.includes(item.id);
      if (exist) this.screen.statusIdList = this.screen.statusIdList.filter((e) => e !== item.id);
      else this.screen.statusIdList.push(item.id);
    },
    // 选择意见
    checkQmType(item) {
      let exist = this.screen.qmTypeIdList.includes(item.id);
      if (exist) this.screen.qmTypeIdList = this.screen.qmTypeIdList.filter((e) => e !== item.id);
      else this.screen.qmTypeIdList.push(item.id);
    },
    // 选择严重
    checkProblemType(item) {
      let exist = this.screen.problemTypeIdList.includes(item.id);
      if (exist) this.screen.problemTypeIdList = this.screen.problemTypeIdList.filter((e) => e !== item.id);
      else this.screen.problemTypeIdList.push(item.id);
    },
    // 打开阶段弹框
    openStage() {
      this.$refs.stageNameSheet.popupShow = true;
    },
    // 设置阶段
    setStage(list) {
      let stageList = list || [];
      let stageIdList = stageList.map((e) => e.id);
      this.$set(this.screen, "stageIdList", stageIdList);
      this.$set(this.screen, "stageNames", stageList.map((e) => e.cnName).join());
    },
    // 打开子项弹框
    openChild() {
      this.$refs.childNameSheet.popupShow = true;
    },
    // 设置子项
    setChild(list) {
      let stageChildList = list || [];
      let stageChildIdList = stageChildList.map((e) => e.id);
      this.$set(this.screen, "stageChildIdList", stageChildIdList);
      this.$set(this.screen, "stageChildNames", stageChildList.map((e) => e.cnName).join());
    },
    // 打开专业弹框
    openSpec() {
      this.$refs.specNameSheet.popupShow = true;
    },
    // 设置专业
    setSpec(list) {
      let specList = list || [];
      let specIdList = specList.map((e) => e.id);
      this.$set(this.screen, "specIdList", specIdList);
      this.$set(this.screen, "specNames", specList.map((e) => e.cnName).join());
    },
    // 打开跨专业弹框
    openMultiSpec() {
      this.$refs.multiSpecSheet.popupShow = true;
    },
    // 设置跨专业
    setMultiSpec(list) {
      let multiSpecList = list || [];
      let multiSpecIdList = multiSpecList.map((e) => e.id);
      this.$set(this.screen, "multiSpecList", multiSpecIdList);
      this.$set(this.screen, "multiSpecNames", multiSpecList.map((e) => e.cnName).join());
    },
    // 打开修改人弹框
    openModifier() {
      this.$refs.modifierSheet.popupShow = true;
    },
    // 设置修改人
    setModifier(list) {
      let modifierList = list || [];
      let modifierIdList = modifierList.map((e) => e.id);
      this.$set(this.screen, "modifierIdList", modifierIdList);
      this.$set(this.screen, "modifierNames", modifierList.map((e) => e.name).join());
    },
    // 打开创建人弹框
    openCreator() {
      this.$refs.creatorSheet.popupShow = true;
    },
    // 设置创建人
    setCreator(list) {
      let creatorList = list || [];
      let createUserIdList = creatorList.map((e) => e.id);
      this.$set(this.screen, "createUserIdList", createUserIdList);
      this.$set(this.screen, "creatorNames", creatorList.map((e) => e.name).join());
    },
    // 打开来源弹框
    openSource() {
      this.$refs.sourceSheet.popupShow = true;
    },
    // 设置来源
    setSource(list) {
      let sourceList = list || [];
      let sourceNameList = sourceList.map((e) => e.cnName);
      this.$set(this.screen, "sourceList", sourceNameList);
      this.$set(this.screen, "sourceNames", sourceNameList.join());
    },
    // 设置起始时间
    setStartTime(date) {
      this.screen.startCreateTime = moment(date).format("YYYY-MM-DD 00:00:00");
      this.startTimeShow = false;
    },
    // 清空起始时间
    clearStartTime() {
      this.$refs.startTime.reset();
      this.screen.startCreateTime = "";
      this.startTimeShow = false;
    },
    // 设置结束时间
    setEndTime(date) {
      this.screen.endCreateTime = moment(date).format("YYYY-MM-DD 23:59:59");
      this.endTimeShow = false;
    },
    // 清空结束时间
    clearEndTime() {
      this.$refs.endTime.reset();
      this.screen.endCreateTime = "";
      this.endTimeShow = false;
    },

    // 确定
    submit() {
      this.$emit("callback", this.screen);
      this.popupShow = false;
    },
    // 重置
    reset() {
      this.screen = new FormData();
      this.clearPopup();
      this.$refs.startTime.reset();
      this.$refs.endTime.reset();
      this.$emit("callback", this.screen);
    },
    // 清空弹框选中
    clearPopup() {
      this.$refs.stageNameSheet.clear();
      this.$refs.childNameSheet.clear();
      this.$refs.specNameSheet.clear();
      this.$refs.multiSpecSheet.clear();
      this.$refs.modifierSheet.clear();
      this.$refs.creatorSheet.clear();
      this.$refs.sourceSheet.clear();
    }
  }
};
</script>

<style lang="scss" scoped>
.screenArea {
  width: 320px;
  max-width: 80vw;
  height: 100vh;
  display: flex;
  flex-direction: column;

  .title {
    font-size: 20px;
    line-height: 10vh;
    text-align: center;
  }
  .content {
    height: 1px;
    flex-grow: 1;
    overflow: auto;
    .label {
      padding: 0 16px;
    }
  }
  .buttons {
    display: flex;
    justify-content: space-evenly;
    padding: 20px 0;
    .button {
      width: 40%;
      height: 40px;
    }
  }
}
.timeBtn {
  width: 100%;
  height: 34px;
  margin: 8px 0;
}

::v-deep .checkCell {
  &::after {
    border-bottom: none;
  }
  .van-field__control {
    display: flex;
    flex-wrap: wrap;
  }
  .checkBtn {
    &:last-child {
      margin-right: 0;
    }
    min-width: 64px;
    margin-right: 8px;
    margin-bottom: 6px;
  }
  .checkedBtn {
    color: #4777e7;
    border: 1px solid #4777e7;
    &::after {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 16px;
      height: 16px;
      padding-right: 1px;
      content: "✓";
      color: white;
      font-size: 10px;
      line-height: 22px;
      text-align: right;
      clip-path: polygon(0 100%, 100% 0, 100% 100%);
      background-color: #4777e7;
    }
  }
}
</style>
